export const GET_RESOURCE_CONTENT = " GET_RESOURCE_CONTENT";
export const IS_FETCHING_RESOURCE_DATA = " IS_FETCHING_RESOURCE_DATA";
export const IS_ERROR_GETTING_RESOURCE_DATA = " IS_ERROR_GETTING_RESOURCE_DATA";
